export const makeUri = (...chunks: (string | number)[]): string => {
	return chunks.join('/');
};

export function convertMultipleSpacesIntoOne(value: string): string {
	return value.replace(/\s\s+/g, ' ');
}
